import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Flex } from "@radix-ui/themes";
import { useGateValue } from "@statsig/react-bindings";
import { useEffect } from "react";
import Audiomack from "@/components/Audiomack";
import { noindexHead } from "@/lib/seo";

export const Route = createFileRoute(
  "/audiomack/D6AFDC8EBDFCDC7C93C8D33551D4B5A2",
)({
  component: RouteComponent,
  head: () => noindexHead("Audiomack | Lutely"),
});

function RouteComponent() {
  const navigate = useNavigate();
  // Hidden by default. The page only renders when `show_audiomack_page` passes
  const showAudiomackPage = useGateValue("show_audiomack_page");

  useEffect(() => {
    if (!showAudiomackPage) {
      navigate({ to: "/artists", replace: true });
    }
  }, [showAudiomackPage, navigate]);

  if (!showAudiomackPage) {
    return null;
  }

  return (
    <Flex
      className="w-full h-full"
      align="center"
      justify="center"
      direction="column"
    >
      <Audiomack />
    </Flex>
  );
}
